module.exports = __webpack_public_path__ + "static/analysis-0ba26b4bd0efacfc6ada10038f7fdcbd.svg";